<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div class="form-edit-page row-space">
        <div class="row row-space">   
            <div class="form-item">
                <GabinetePessoaFrame
                    v-model:objSelecionado="pessoaSelecionada" />
            </div>

            <div class="form-item-data">
                <label class="label-caption">Solicitado em:</label>
                <input type="date" v-model="edDataSolicitacao" />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Solicitação</label>
                <input type="text" v-model="edSolicitacao" maxlength="100" v-uppercase />
            </div>

            <div class="form-item-data">
                <label class="label-caption">Prazo</label>
                <input type="date" v-model="edDataPrazo" />
            </div>

            <div class="form-item-char40"><GabineteDepartamentoSelect v-model:departamentoSelecionado="idDepartamento"/></div>
        </div>


        <div class="row-end">
            <button class="btn-small" @click="incluiSolicitacao()">Incluir</button>
            <button class="btn-small" @click="closeForm()">Fechar</button>
        </div>
    </div>


    <div v-if="lsSolicitacoes.length>0">
        <div class="table-wrapper"><table>
            <thead><tr>
                <th>Histórico de Solicitações</th>
                <th>Departamento</th>
                <th>Data</th>
                <th>Prazo</th>
                <th>Dias</th>
                <th>Atendimento</th>
                <th>Situação</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsSolicitacoes" :key="obj.id" :class="getRowClassSolicitacoes(index, obj.ttdias_aguardando)">
                    <td>{{ obj.solicitacao }}</td>
                    <td class="col-width-char40">{{ obj.nmdepartamento }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtsolicitacao) }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtprazo) }}</td>
                    <td class="col-width-char05 center" :class="{ 'td-alert': obj.ttdias_aguardando < 0 }">
                        {{ Funcoes.formatInteger(obj.ttdias_aguardando) }}</td>
                    <td class="col-width-char15 center">{{ obj.dhatendimento }}</td>
                    <td class="col-width-char15" :class="{ 'td-alert': obj.ttdias_aguardando < 0 }">
                        {{ obj.nmstatus }}</td>
                </tr>
            </tbody>
        </table></div>
    </div>
</template>
  
<script setup>
import { watch, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import GabineteDepartamentoSelect from '@/selects/GabineteDepartamentoSelect.vue';
import GabinetePessoaFrame from '@/components/frames/GabinetePessoaFrame.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit=defineEmits(['close', 'salvo'])

const edDataPrazo = ref(null);
const edDataSolicitacao = ref(Funcoes.dataAtual());
const edSolicitacao = ref(null);
const msgAlerta = ref(false);
const idDepartamento = ref(null);
const isLoading = ref(false);
const pessoaSelecionada = ref(null);
const lsSolicitacoes = ref([]);


function getRowClassSolicitacoes(index, ttdias){
    if (ttdias < -100000) return 'alert-row';
    return index % 2 === 0 ? 'even-row' : 'odd-row';
}


watch(pessoaSelecionada, (novaPessoa) => {
    const temDados = novaPessoa && Object.keys(novaPessoa).length > 0;

    if (temDados) {
        lerSolicitacoes();
    } else {
        lsSolicitacoes.value = []; // limpa / fecha lista
    }
}, { deep: true });


function closeForm(){
    emit('close');
}


async function incluiSolicitacao(){
    try {
        msgAlerta.value=null;
        msgAlerta.value = validarDadosSolicitacao();
        if (msgAlerta.value) return;

        isLoading.value=true;
        const r = await Api.genericPut('/cad/gabinete_solicitacao', {
            idmunicipio: globalStore.idmunicipio,
            idpessoa: pessoaSelecionada.value.id, //to-do: permitir selecionar quando usar lista
            iddepartamento: idDepartamento.value,
            dtsolicitacao: edDataSolicitacao.value,
            dtprazo: edDataPrazo.value,
            solicitacao: edSolicitacao.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (r.bolok===1){
            await lerSolicitacoes();
            edSolicitacao.value=null;
        } else {msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value=false;}
}


const lerSolicitacoes = async() => {
    try{
        msgAlerta.value=null;
        const req = await Api.genericPost('/listas/gabinete/solicitacoes', {
            idmunicipio: globalStore.idmunicipio, 
            idpessoa: pessoaSelecionada.value.id});
        lsSolicitacoes.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`}
}


function validarDadosSolicitacao(){
    let r = Validar.id(pessoaSelecionada.value, 'Informe o código da pessoa que está solicitando');
    if (!r.ok) return r.msg;

    r = Validar.data(edDataSolicitacao.value, 0, 'Solicitação');
    if (!r.ok) return r.msg;

    r = Validar.texto(edSolicitacao.value, 'Informe a solicitação');
    if (!r.ok) return r.msg;

    r = Validar.data(edDataPrazo.value, 0, 'Prazo');
    if (!r.ok) return r.msg;

    r = Validar.numeroPositivo(idDepartamento.value, 'Informe o departamento');
    if (!r.ok) return r.msg;

    return null;
}
</script>
